import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]

import tenkoAssociationType from "@/types/responses/getIttenkoAssociation";


export default /*@__PURE__*/_defineComponent({
  __name: 'DeleteIcon',
  props: {
    tenkoAssociation: {}
  },
  emits: ['openDeleteModal'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit
const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('openDeleteModal', props.tenkoAssociation))),
    class: "material-symbols-outlined",
    disabled: !props.tenkoAssociation,
    style: _normalizeStyle(!props.tenkoAssociation ? 'opacity: 0.5' : '')
  }, " delete ", 12, _hoisted_1))
}
}

})